<div class="body" [formGroup]="formGroup">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>add</mat-icon>
        </button>
        <span>Angebot anlegen</span>
        <span class="spacer"></span>
        <span matSuffix>

            <button mat-icon-button *ngIf="!(service.checkerVisible$|async)" (click)="service.setDoubletCheckerVisible(true)" matTooltip="Dubletten anzeigen">
                <mat-icon>manage_search</mat-icon>
            </button>

            <button mat-icon-button color="warn" (click)="close()">
                <mat-icon>close</mat-icon>
            </button>

        </span>
    </mat-toolbar>

    <div class="content" [formGroup]="formGroup">

        <app-offer-form formGroupName="offer"></app-offer-form>

    </div>

    <div class="footer">

        <button [disabled]="formGroup.invalid" (click)="saveOffer()" mat-raised-button color="primary">
            Speichern
        </button>

    </div>

</div>
